module.exports = __webpack_public_path__ + "img/astana5.9eaa511d.jpg";